import React from 'react';
import '../styles/Topicon.css';
            
const Topicon = () => (
   <>  
        <a href="#inicio" id="topo"> </a>
    </>


);

export default Topicon;
            